"use client";

import MainComponentPreAuth from "@/app/component/main-component-preauth";
import { ReactNode } from "react";

export default function RootLayout({
  // modalLogin,
  children,
}: Readonly<{
  // modalLogin: ReactNode;
  children: ReactNode;
}>) {
  // const pathname = usePathname();
  // const router = useRouter();

  // console.log("pathNameee", pathname);

  // if ([`/landing`, ""]?.includes(pathname)) {
  //   router.push(AppRoutes.login);
  // }

  return (
    <MainComponentPreAuth>
      {/* {modalLogin} */}
      {children}
    </MainComponentPreAuth>
  );
}
